import { GetPartnerWorkerResponse } from 'partner/shared/services/partner-worker-service.types';
import { useTranslation } from 'react-i18next';
import { ModalPanelTabType } from 'redesign';
import { PartnerWorkerDetailAccreditations } from '../partner-worker-detail-modal/partner-worker-detail-accreditations';
import { PartnerWorkerDetailExperience } from '../partner-worker-detail-modal/partner-worker-detail-experience';
import { PartnerWorkerDetailClaView } from '../partner-worker-detail-modal/partner-worker-detail-cla/partner-worker-detail-cla-view';

enum PartnerWorkerDetailTab {
  ACCREDITATIONS = 'accreditations',
  EXPERIENCE = 'experience',
  CLA = 'cla',
}

export const useGetPartnerWorkerDetailTabs = (data: GetPartnerWorkerResponse) => {
  const { t } = useTranslation('partner-screen-specific');

  const tabs: ModalPanelTabType[] = [
    {
      id: PartnerWorkerDetailTab.ACCREDITATIONS,
      tabLabel: t('partner-worker-detail.tabs.accreditations'),
      element: <PartnerWorkerDetailAccreditations accreditations={data.accreditations} />,
    },
    {
      id: PartnerWorkerDetailTab.EXPERIENCE,
      tabLabel: t('partner-worker-detail.tabs.experience'),
      element: <PartnerWorkerDetailExperience data={data} />,
    },
    {
      id: PartnerWorkerDetailTab.CLA,
      tabLabel: t('partner-worker-detail.tabs.cla'),
      element: (
        <PartnerWorkerDetailClaView
          workerId={data.id}
          clas={data.collectiveLabourAgreements ?? []}
        />
      ),
    },
  ];

  return tabs;
};
